module.exports = __webpack_public_path__ + "img/maple-mustard-broiled-salmon.6c8af05a.jpg";